let unFlatten = function (
  list: any[],
  parent = null,
  options: { parentKey: string; childrenKey: string; key: string } = {
    parentKey: "parent",
    childrenKey: "children",
    key: "id",
  }
): any {
  const { parentKey, childrenKey, key } = options;
  if (!list) return [];
  return list
    .filter((item) => item[parentKey] === parent)
    .map((item) => ({ ...item, children: unFlatten(list, item[key]) }));
};

export default unFlatten;
